<div
  id="kt_app_sidebar"
  class="app-sidebar flex-column"
  data-kt-drawer="true"
  data-kt-drawer-name="app-sidebar"
  data-kt-drawer-activate="{default: true, lg: false}"
  data-kt-drawer-overlay="true"
  data-kt-drawer-width="225px"
  data-kt-drawer-direction="start"
  data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
>
  <!-- PWA Title Bar Area -->
  <div
    class="pwa-titlebar-area"
    style="
      height: var(--titlebar-area-height);
      min-height: var(--titlebar-area-height);
      width: 100%;
    "
  ></div>

  <!-- Logo section -->
  <div class="app-sidebar-logo px-8" id="kt_app_sidebar_logo">
    <div class="overflow-hidden">
      <div class="d-flex align-items-center">
        <svg
          width="17"
          height="34"
          viewBox="0 0 17 34"
          xmlns="http://www.w3.org/2000/svg"
          class="logo-size"
          style="height: 40px; width: auto; overflow: visible"
          aria-label="Logo Part 1"
          role="img"
        >
          <g clip-path="url(#sidebarLogoClip0)">
            <g clip-path="url(#sidebarLogoClip1)">
              <path
                d="M0.0586207 20.1591C0.0464952 14.9489 4.13171 10.6863 8.99405 10.6863H10.6475C11.445 10.6858 12.2318 10.4897 12.9477 10.1131C13.6636 9.73655 14.2897 9.18944 14.7779 8.51367V15.4546C14.7787 16.6996 14.4734 17.923 13.8929 19.0015C13.3124 20.08 12.477 20.9755 11.471 21.598L4.38964 25.9787C3.90405 26.2827 3.32801 26.3752 2.78064 26.2369C2.23326 26.0986 1.7564 25.7401 1.44865 25.2356C0.540998 23.7212 0.0585119 21.959 0.0586207 20.1591Z"
                fill="var(--brand-primary)"
              />
              <path
                d="M3.50392 17.2538C3.49584 13.7804 6.21932 10.9386 9.46087 10.9387H10.5632C11.0948 10.9383 11.6194 10.8076 12.0967 10.5565C12.5739 10.3055 12.9913 9.94075 13.3168 9.49023L13.3168 14.1175C13.3173 14.9475 13.1138 15.7631 12.7268 16.4821C12.3398 17.201 11.7829 17.7981 11.1122 18.2131L6.39127 21.1336C6.06753 21.3362 5.68351 21.3979 5.3186 21.3057C4.95368 21.2134 4.63577 20.9744 4.43061 20.6382C3.82551 19.6286 3.50385 18.4538 3.50392 17.2538Z"
                fill="#2B2B2B"
              />
            </g>
          </g>
          <defs>
            <clipPath id="sidebarLogoClip0">
              <rect width="17" height="34" fill="white" />
            </clipPath>
            <clipPath id="sidebarLogoClip1">
              <rect width="143.99" height="33.3" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <img
          alt="Logo Part 2"
          src="assets/media/Sidebar-Logo-2.svg"
          class="logo-size"
          style="height: 40px; width: auto; margin-left: 0.1rem"
        />
      </div>
    </div>
    <!-- Toggle Sidebar Button -->
    <div
      id="kt_app_sidebar_toggle"
      class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
      data-kt-toggle="true"
      data-kt-toggle-state="active"
      data-kt-toggle-target="body"
      data-kt-toggle-name="app-sidebar-minimize"
      (click)="toggleFooterVisibility()"
    >
      <i
        class="fa-solid fa-arrow-left"
        [ngClass]="isSidebarMinimized ? 'sidebar-arrow-collapsed' : 'sidebar-arrow-expanded'"
      ></i>
    </div>
  </div>

  <!-- Organization section -->
  <div id="kt_app_sidebar_org" *ngIf="orgName" class="org-section px-4">
    <div class="org-chip">
      <img
        *ngIf="orgAvatar; else orgInitials"
        [src]="orgAvatar"
        [alt]="orgName"
        class="org-avatar-circle"
        [title]="orgName"
      />
      <ng-template #orgInitials>
        <div class="org-avatar-initials" [title]="orgName">
          {{ orgName.charAt(0).toUpperCase() }}
        </div>
      </ng-template>
      <span class="org-name">{{ orgName }}</span>
    </div>
  </div>

  <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
    <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper">
      <div
        id="kt_app_sidebar_menu_scroll"
        class="scroll-y my-5 mx-3 pb-4"
        [class.has-org]="orgName"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_org, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
      >
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6 mb-20"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <div *ngFor="let item of menuTopItems">
            <div class="menu-item">
              <!-- Main Menu -->
              <a
                *ngIf="!item.subMenu"
                class="menu-link"
                [routerLink]="[item.link]"
              >
                <span class="menu-icon">
                  <i [class]="item.icon"></i>
                </span>
                <span class="menu-title">{{ item.title | translate }}</span>
              </a>
              <!-- Sub Menu -->
              <div
                *ngIf="item.subMenu"
                data-kt-menu-trigger="click"
                class="menu-item menu-accordion"
              >
                <span class="menu-link cursor-pointer">
                  <span class="menu-icon">
                    <i [class]="item.icon"></i>
                  </span>
                  <span class="menu-title">{{ item.title | translate }}</span>
                  <span class="menu-arrow"></span>
                </span>
                <div class="menu-sub menu-sub-accordion">
                  <div *ngFor="let subItem of item.subMenu" class="menu-item">
                    <a class="menu-link" [routerLink]="[subItem.link]">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{
                        subItem.title | translate
                      }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6 mt-15 pb-8"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <!-- User -->
          <div
            class="menu-item cursor-pointer ms-1"
            [routerLink]="['/profile/detail']"
          >
            <a class="menu-link pb-0 ps-3">
              <!-- user -->
              <div class="d-flex align-items-center">
                <span class="menu-icon symbol symbol-50px">
                  <a
                    class="btn btn-icon w-35px h-35px cursor-pointer"
                    data-kt-menu-trigger="hover"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="top-start"
                  >
                    <span class="menu-icon me-0">
                      <img
                        *ngIf="userAvatar; else defaultAvatar"
                        alt="Logo"
                        [src]="userAvatar"
                        class="rounded-circle"
                      />
                      <ng-template #defaultAvatar>
                        <i class="fa-regular fa-user"></i>
                      </ng-template>
                    </span>
                  </a>
                </span>
                <span class="menu-title fw-bold">
                  {{
                    (currentUser?.firstName || "") +
                      " " +
                      (currentUser?.lastName || "")
                  }}
                </span>
              </div>
            </a>
          </div>
          <!-- Notification -->
          <div class="menu-item cursor-pointer position-relative">
            <a (click)="toggleNotificationCard($event)" class="menu-link ps-3">
              <span class="menu-icon">
                <i class="fa fa-bell"></i>
                <span *ngIf="unreadCount > 0" class="notif-badge-sm">{{
                  unreadCount
                }}</span>
              </span>
              <span class="menu-title">{{ "notification" | translate }}</span>
            </a>

            <div
              *ngIf="isNotificationCardOpen"
              class="notification-card animate__animated animate__fadeInLeft animate__faster"
              [ngStyle]="notificationCardStyle"
              (click)="$event.stopPropagation()"
            >
              <div class="card-header">
                <h6 class="m-0">{{ "notification" | translate }}</h6>
              </div>

              <div class="card-body p-0 scroll-y">
                <div
                  *ngFor="let n of notifications"
                  (click)="onNotificationClick(n)"
                  class="notification-row"
                >
                  <div class="fw-bold">{{ n.title }}</div>
                  <div class="text-muted fs-7">{{ n.content }}</div>
                </div>
              </div>

              <div class="card-footer p-2 text-center">
                <button
                  class="btn btn-sm btn-link"
                  (click)="onShowAllNotification()"
                >
                  {{ "Show All Notification" | translate }}
                </button>
              </div>
            </div>
          </div>
          <!-- Settings -->
          <div
            *ngIf="currentUser?.role == userRole.Admin"
            class="menu-item cursor-pointer"
          >
            <a (click)="navigateToSettings()" class="menu-link pb-0 ps-3">
              <span class="menu-icon">
                <i class="fa-solid fa-gear" aria-hidden="true"></i>
              </span>
              <span class="menu-title">{{ "settings" | translate }}</span>
            </a>
          </div>
          <!-- Info Menu -->
          <div
            [routerLink]="['/infoPage/info']"
            class="menu-item cursor-pointer"
          >
            <a
              class="menu-link ps-0 pb-0"
              [ngClass]="{ 'pt-0': currentUser?.role !== userRole.Admin }"
              data-kt-menu-trigger="hover"
              data-kt-menu-attach="parent"
              data-kt-menu-placement="top-start"
            >
              <div class="d-flex flex-column align-items-center">
                <div class="app-navbar-item">
                  <div class="menu-link ps-3">
                    <span class="menu-icon">
                      <i
                        class="fa-solid fa-circle-info info"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span class="menu-title fw-bold">{{
                      "info" | translate
                    }}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <!-- Sign out -->
          <div class="menu-item cursor-pointer">
            <a (click)="showLogoutConfirmation()" class="menu-link ps-3">
              <span class="menu-icon">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
              </span>
              <span class="menu-title">{{ "logout" | translate }}</span>
            </a>
          </div>

          <!-- Made with by Amatis -->
          <div class="menu-item mt-auto">
            <div style="position: relative; height: 2rem">
              <div
                class="text-center pb-3"
                style="position: absolute; top: 0; left: 0; right: 0"
                [ngClass]="
                  !isFooterHidden || (isFooterHidden && isSidebarHovered)
                    ? 'footer-visible'
                    : 'footer-hidden'
                "
              >
                <span
                  class="text-muted fw-semibold"
                  style="font-size: 0.75rem"
                  [innerHTML]="
                    'footerCredits'
                      | translate
                        : {
                            version: version,
                            company: 'Amatis',
                            heart:
                              '<i class=\'fa-solid fa-heart heart-icon\'></i>',
                          }
                  "
                >
                </span>
              </div>
              <div
                class="text-start pb-3 ps-3"
                style="position: absolute; top: 0; left: 0; right: 0"
                [ngClass]="
                  isFooterHidden && !isSidebarHovered
                    ? 'footer-visible'
                    : 'footer-hidden'
                "
              >
                <span class="text-muted fw-semibold" style="font-size: 0.75rem">
                  {{ version }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Logout Confirmation Modal -->
<div
  class="modal fade"
  id="logoutConfirmationModal"
  tabindex="-1"
  aria-labelledby="logoutModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="logoutModalLabel">
          {{ "confirmLogout" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "areYouSureYouWantToLogout" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="confirmLogout()"
          data-bs-dismiss="modal"
        >
          {{ "logout" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
